import React from 'react';
import { GiChicken, GiDrinkMe, GiGps } from 'react-icons/gi';

const Features = () => {
  const features = [
    {
      icon: <GiDrinkMe className="w-12 h-12 text-[#E57373]" />,
      title: "Collective Fun",
      description: "Join forces with friends as you pool your resources into a shared pot—where every drink matters!",
      image: "ctc-fun.jpg"
    },
    {
      icon: <GiChicken className="w-12 h-12 text-[#E57373]" />,
      title: "Dynamic Game Setup",
      description: "Tailor each game to your group's preferences—choose boundaries, roles, and more for endless replayability!",
      image: "ctc-games.jpg"
    },
    {
      icon: <GiGps className="w-12 h-12 text-[#E57373]" />,
      title: "Thrilling Live Tracking",
      description: "Feel the suspense as Chickens evade capture—watch your friends' movements in real-time with our app's tracking feature!",
      image: "ctc-uav.jpeg"
    }
  ];

  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-medium text-gray-800 mb-4 text-center">Features</h2>
        <p className="text-xl text-gray-600 text-center mb-12">
          Experience the thrill of <span className="text-[#E57373] font-medium">Chase the Chickens</span> with these exciting features!
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl overflow-hidden hover:shadow-xl transition duration-300"
            >
              <div className="relative">
                <img 
                  src={feature.image} 
                  alt={feature.title} 
                  className="w-full aspect-square object-cover"
                />
                <div className="absolute -bottom-6 right-6 bg-white rounded-full p-3 shadow-lg">
                  {feature.icon}
                </div>
              </div>
              <div className="p-6 pt-8">
                <h3 className="text-2xl font-medium text-gray-800 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;